export default __webpack_public_path__ + "src/assets/icn-platform-used.1ad20bcd7176def0d61a5cb6cfe9d8b4.svg";